import React from 'react';
import { Link as RouterLink } from 'react-router';
import { Box, Typography } from '@mui/material';
import AiInsightsLogo from '@/components/layout/AiInsightsLogo';

interface DrawerHeaderProps {
    isOpen: boolean;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({ isOpen }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                px: 1,
                py: 2,
                height: '76px',
            }}
        >
            <Box
                component={RouterLink}
                to="/"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    color: 'inherit',
                }}
            >
                <Box sx={{ width: 24, height: 24, ml: 0.15 }}>
                    <AiInsightsLogo />
                </Box>
                {isOpen && (
                    <Typography variant="h3" sx={{ fontWeight: 'bold', ml: 0.75, color: 'inherit' }}>
                        AI Insights
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default DrawerHeader;
